import { render, staticRenderFns } from "./CarefullyChosenPage.vue?vue&type=template&id=a07babc4&scoped=true&"
import script from "./CarefullyChosenPage.vue?vue&type=script&lang=js&"
export * from "./CarefullyChosenPage.vue?vue&type=script&lang=js&"
import style0 from "./CarefullyChosenPage.vue?vue&type=style&index=0&id=a07babc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07babc4",
  null
  
)

export default component.exports